import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import './index.scss';
import App from './App';
import * as serviceWorker from './serviceWorker';
//import { createBrowserHistory } from 'history';

//const history = createBrowserHistory();

//history.listen(location => {
  //ReactGA.set({ page: location.pathname }); // Update the user's current page
  //ReactGA.pageview(location.pathname); // Record a pageview for the given page
//});

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
